import { render, staticRenderFns } from "./Formatter.vue?vue&type=template&id=3bab280c&"
import script from "./Formatter.vue?vue&type=script&lang=js&"
export * from "./Formatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports